import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { NumberField } from '../../../../../ui/_fields/NumberField/NumberField';
import { TextField } from '../../../../../ui/_fields/TextField/TextField';
import { TextareaFieldInput } from '../../../../../ui/_fields/TextareaFieldInput/TextareaFieldInput';
import {
  CONTEST_TRIGGER_MAX,
  ContestRewardType,
  ContestTriggerFormValues,
} from './contestTriggerShared';
import { EpisodeUuidLookupHint } from './EpisodeUuidLookupHint';

export interface ContestTriggerV1PanelProps {
  values: ContestTriggerFormValues
  errors: Partial<Record<keyof ContestTriggerFormValues, string>> | undefined
  touched: Partial<Record<keyof ContestTriggerFormValues, boolean>> | undefined
  onChange: (event: React.ChangeEvent) => void
  onRewardAmountChange: (value: number) => void
}

export function ContestTriggerV1Panel(props: ContestTriggerV1PanelProps) {
  const {
    values,
    errors,
    touched,
    onChange,
    onRewardAmountChange,
  } = props;

  const handleRewardAmountChange = (event: React.ChangeEvent) => {
    const { value } = event.target as HTMLInputElement;
    onRewardAmountChange(value === '' ? 0 : Number(value));
  };

  return (
    <>
      <Row className="mb-3">
        <Col md={12}>
          <TextField
            label="Trigger"
            name="contestTrigger.triggerKey"
            placeholder="Trigger key"
            value={values.triggerKey}
            onChange={onChange}
            error={touched?.triggerKey ? errors?.triggerKey : ''}
            maxLength={CONTEST_TRIGGER_MAX.trigger}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <TextField
            label="Episode UUID"
            name="contestTrigger.episodeUuid"
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
            value={values.episodeUuid}
            onChange={onChange}
            error={touched?.episodeUuid ? errors?.episodeUuid : ''}
          />
          <EpisodeUuidLookupHint uuid={values.episodeUuid} />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Reward type</Form.Label>
            <Form.Control
              as="select"
              name="contestTrigger.rewardType"
              value={values.rewardType}
              onChange={onChange}
            >
              <option value={ContestRewardType.Sapphires}>Sapphires</option>
              <option value={ContestRewardType.Hearts}>Hearts</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={6}>
          <NumberField
            label="Reward amount"
            name="contestTrigger.rewardAmount"
            min="0"
            step="1"
            value={values.rewardAmount}
            onChange={handleRewardAmountChange}
            error={touched?.rewardAmount ? errors?.rewardAmount : ''}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <TextField
            label="Title"
            name="contestTrigger.title"
            placeholder="Mailbox / notification title"
            value={values.title}
            onChange={onChange}
            error={touched?.title ? errors?.title : ''}
            maxLength={CONTEST_TRIGGER_MAX.title}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <TextareaFieldInput
            rows={4}
            label="Message"
            name="contestTrigger.message"
            placeholder="Message body"
            value={values.message}
            onChange={onChange}
            error={touched?.message ? errors?.message : ''}
            maxLength={CONTEST_TRIGGER_MAX.message}
          />
        </Col>
      </Row>
    </>
  );
}
